import { useState } from 'react';
import { Collapse, Button } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';
import ShoppingListProduct from '../Product/ShoppingListProduct';

const ShoppingListCategory = ({ name, products }) => {
  const { t } = useTranslator();
  const [collapse, setCollapse] = useState(false);

  const {
    svgInline: { DownArrow },
  } = useAppContext();

  const toggle = () => {
    setCollapse((prevCollapse) => !prevCollapse);
  };

  const renderArrow = () => {
    if (collapse) {
      return (
        <span className="collapse-arrow open">
          <span className="SVGInline">
            <DownArrow />
          </span>
        </span>
      );
    }

    return (
      <span className="collapse-arrow">
        <span className="SVGInline">
          <DownArrow />
        </span>
      </span>
    );
  };

  const toSort = [...products];

  toSort.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });

  const productBought = toSort.filter((el) => el.isBought);
  const productNotBought = toSort.filter((el) => !el.isBought);

  return (
    <div className="products-category">
      <h3 className="title-medium semi-bold mb-l mt-xl">{name}</h3>

      <ul className="ingredients">
        {productNotBought.map((product) => (
          <ShoppingListProduct key={product.key} product={product} />
        ))}
      </ul>

      <section className="bought-section py-m px-m mt-l">
        <Button className="bought-button d-print-none p-0" onClick={toggle}>
          {t('shoppingList.bought.title')}
          {renderArrow()}
        </Button>

        <Collapse className="d-print-none" isOpen={collapse}>
          {productBought.length > 0 ? (
            <ul className="ingredients">
              {productBought.map((product) => (
                <ShoppingListProduct key={product.key} product={product} />
              ))}
            </ul>
          ) : (
            <p className="no-products m-0">{t('shoppingList.bought.noProducts')}</p>
          )}
        </Collapse>
      </section>
    </div>
  );
};

export default ShoppingListCategory;
